import { Stack } from "expo-router";
import { Text, View } from "@src/components";

/**
 * Native fallback required by Expo Router beside `_layout.web.tsx`. Patriot
 * tools are a dense, web-only support tool with no native entry point, so a
 * deep link here explains that rather than rendering the pages.
 */
export default function PatriotToolsNativeLayout() {
  return (
    <>
      <Stack.Screen options={{ title: "Patriot tools" }} />
      <View flex={1} alignItems="center" justifyContent="center" padding="3xl" gap="md">
        <Text textStyle="sm/semibold" color="text" textAlign="center">
          Patriot tools are only available on the web client.
        </Text>
      </View>
    </>
  );
}
